<p class="h6">
  <span [ngClass]="{'dot-green': dotGreen, 'dot-red': dotRed}"></span>
  <strong>{{ status }} </strong>
</p>
